import React from 'react';
import {
  Alert,
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { BRAND_ORANGE } from '../../Events/ManageEvent/components/manageEventFieldStyles';
import { PARTNER_BRAND } from '../../Partner/partnerDashboardTheme';
import {
  ATTENDEE_ELIGIBILITY_COPY,
  ATTENDEE_ELIGIBILITY_OPTIONS,
  normalizeAttendeeEligibility,
} from '../../../shared/registrationSettings';

const AttendeeEligibilityField = ({
  value,
  onChange,
  error = false,
  helperText = '',
  variant = 'event',
  radioRow = true,
  showInfoAlert,
  bordered = true,
}) => {
  const copy = ATTENDEE_ELIGIBILITY_COPY[variant] ?? ATTENDEE_ELIGIBILITY_COPY.event;
  const shouldShowInfoAlert = showInfoAlert ?? variant === 'event';
  const brandColor = variant === 'community' ? PARTNER_BRAND : BRAND_ORANGE;

  return (
    <Box
      sx={{
        py: variant === 'community' ? 0.5 : 2.5,
        ...(bordered
          ? {
              borderBottom: '1px solid',
              borderColor: 'divider',
            }
          : {}),
      }}
    >
      <Typography
        sx={{
          fontWeight: variant === 'community' ? 700 : 600,
          fontSize: variant === 'community' ? '0.875rem' : '0.9375rem',
          color: 'text.primary',
          mb: 0.5,
        }}
      >
        Attendee Eligibility
      </Typography>
      <Typography
        sx={{
          fontSize: '0.8125rem',
          color: 'text.secondary',
          lineHeight: 1.45,
          mb: 1.75,
        }}
      >
        {copy.description}
      </Typography>

      <FormControl error={error} sx={{ width: '100%' }}>
        <RadioGroup
          row={radioRow}
          value={normalizeAttendeeEligibility(value)}
          onChange={(event) => onChange(event.target.value)}
          sx={{
            gap: radioRow ? { xs: 0.5, sm: 2 } : 0,
            flexWrap: radioRow ? 'wrap' : 'nowrap',
          }}
        >
          {ATTENDEE_ELIGIBILITY_OPTIONS.map((option) => {
            const isSelected = normalizeAttendeeEligibility(value) === option.value;

            return (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={
                  <Radio
                    size={variant === 'community' ? 'small' : 'medium'}
                    sx={{
                      color: 'text.disabled',
                      '&.Mui-checked': {
                        color: brandColor,
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: '0.875rem',
                      fontWeight: variant === 'community' ? 500 : 400,
                      color:
                        variant === 'community'
                          ? isSelected
                            ? 'text.primary'
                            : 'text.secondary'
                          : 'text.primary',
                    }}
                  >
                    {option.label}
                  </Typography>
                }
                sx={{
                  mr: 0,
                  mb: variant === 'community' ? 0.25 : 0,
                }}
              />
            );
          })}
        </RadioGroup>
        {helperText ? <FormHelperText sx={{ mx: 0 }}>{helperText}</FormHelperText> : null}
      </FormControl>

      {shouldShowInfoAlert && copy.infoAlert ? (
        <Alert
          severity="info"
          sx={{
            mt: 2,
            borderRadius: 2,
            bgcolor: '#EFF6FF',
            color: '#1E3A8A',
            alignItems: 'flex-start',
            '& .MuiAlert-icon': {
              color: '#2563EB',
            },
          }}
        >
          {copy.infoAlert}
        </Alert>
      ) : null}
    </Box>
  );
};

export default AttendeeEligibilityField;
